import { render, staticRenderFns } from "./LoginSeller.vue?vue&type=template&id=27b955ed&scoped=true"
import script from "./LoginSeller.vue?vue&type=script&lang=js"
export * from "./LoginSeller.vue?vue&type=script&lang=js"
import style0 from "./LoginSeller.vue?vue&type=style&index=0&id=27b955ed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b955ed",
  null
  
)

export default component.exports